<template>
  <div ref="section" class="section-panel" :class="{'sp-section': height < scrollHeight}" :style="{height: height+'px'}" v-html="content" />
  <div v-if="showIcon" class="mg-b-20 mg-t-30 text-center">
    <span class="down-icon icon-shuangxiala iconfont" :class="{'rotate': height === scrollHeight}" @click="open" />
  </div>
</template>

<script>
import { onMounted, ref, watch } from 'vue'
import { nextTick } from '@vue/runtime-core'
import SpMessage from '@/components/common/SpMessage'

export default {
  name: 'SpSection',
  props: {
    content: {
      type: String,
      default: ''
    },

    baseHeight: {
      type: Number,
      default: 56
    }
  },

  setup (props, ctx) {
    const section = ref()
    const height = ref(0)
    const scrollHeight = ref(0)
    const showIcon = ref(false)

    watch(() => props.content, (val) => {
      if (val) {
        const obj = section.value
        nextTick(() => {
          if (section.value?.scrollHeight > props.baseHeight) {
            showIcon.value = true
            height.value = props.baseHeight
            scrollHeight.value = obj.scrollHeight
          }
          if (section.value?.scrollHeight <= props.baseHeight) {
            showIcon.value = false
            height.value = section.value?.scrollHeight
          }
        })
      } else {
        showIcon.value = false
        height.value = 0
      }
    })
    const open = () => {
      if (height.value === scrollHeight.value) {
        height.value = props.baseHeight
      } else {
        height.value = scrollHeight.value
      }
    }

    return {
      section,
      height,
      scrollHeight,
      showIcon,
      open
    }
  }
}
</script>

<style scoped lang="less">
.section-panel{
  //font-family: Arial;
  transition: all 0.5s;
  white-space: pre-wrap;
}
.sp-section {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-break: break-word;
  white-space: pre-wrap;
}
.down-icon{
  display: inline-block;
  transition: all 0.5s;
  opacity: 0.4;
  font-size: 16px;
  &.rotate {
    transition: all 0.5s;
    transform:rotate(-180deg);
    -ms-transform:rotate(-180deg); /* Internet Explorer */
    -moz-transform:rotate(-180deg); /* Firefox */
    -webkit-transform:rotate(-180deg); /* Safari 和 Chrome */
    -o-transform:rotate(-180deg); /* Opera */
  }
}
.down-icon:hover {

}
</style>
